import { SVGProps } from 'react';

export function CatScaredFace(props: SVGProps<SVGSVGElement>) {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" data-testid="cat-scared-face" {...props}>
      <g id="color">
        <path
          fill="#F4AA41"
          d="M58.3627,49.2828c-3.5496,8.9951-12.4626,14.8105-22.8972,14.8105 c-8.9955,0-18.9987-5.6278-22.5483-14.6229l-0.1245-0.3085c-1.1262-2.8215-0.9311-6.2749-0.9311-9.5037l3.6179-31.9254 l10.0781,9.9318c2.8836-1.231,6.055-1.9129,9.3833-1.9129h1.0493c3.3283,0,6.4997,0.6818,9.3833,1.9129L56.4516,6.7328 l3.6726,33.4233c0,3.2288-0.6199,6.3115-1.7471,9.1329"
        />
        <path
          fill="#E27022"
          d="M35.4655,64.0933c10.4671,0.3379,20.0822-5.782,23.6318-14.7771l0.1094-0.2279 c1.1262-2.8215,0.9317-6.8043,0.9317-10.0331L56.4516,6.7328"
        />
        <ellipse cx="36" cy="51.7194" rx="6.4518" ry="7.7514" fill="#EA5A47" />
        <ellipse
          cx="24.4558"
          cy="34.194"
          rx="7.7513"
          ry="6.4517"
          transform="matrix(0.3339 -0.9426 0.9426 0.3339 -15.9415 45.8287)"
          fill="#FFFFFF"
        />
        <ellipse
          cx="46.8396"
          cy="34.1948"
          rx="6.4517"
          ry="7.7513"
          transform="matrix(0.9426 -0.3339 0.3339 0.9426 -8.7295 17.6024)"
          fill="#FFFFFF"
        />
        <path
          fill="#F4AA41"
          d="M15.2952,65h9.0343c0,0,1.3738-13.3688,0-15.8101c-0.9984-1.7742-2.5479-5.2709-6.8527-5.1379 c-1.5576,0.0481-6.0111,1.347-4.7097,5.2514c1.8131,5.4394,3.4222,4.5051,4.2929,6.1777C18.2042,57.6789,15.2952,65,15.2952,65z"
        />
        <path
          fill="#F4AA41"
          d="M56.3242,65h-9.0343c0,0-1.3738-13.3688,0-15.8101c0.9984-1.7742,2.5479-5.2709,6.8527-5.1379 c1.5577,0.0481,6.0111,1.347,4.7097,5.2514c-1.8131,5.4394-3.4222,4.5051-4.2929,6.1777C53.4152,57.6789,56.3242,65,56.3242,65z"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <line
          x1="61.65"
          x2="57.61"
          y1="54.4498"
          y2="52.1998"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="57.55"
          x2="54.34"
          y1="59.5798"
          y2="57.7998"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M12.92,46.4798c0,0-0.01-0.01,0-0.01c-0.67-2.19-1.03-4.5-1.03-6.9l3.59-32.32l10.83,10.57c2.82-1.19,5.92-1.85,9.18-1.85h1.02 c3.26,0,6.36,0.66,9.18,1.85l10.83-10.57l3.59,32.32c0,2.59-0.41,5.07-1.19,7.4"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M24.7,60.5598c3.23,1.67,6.9,2.61,10.79,2.61h1.02c3.75,0,7.28-0.87,10.43-2.42"
        />
        <line
          x1="14.1"
          x2="10.35"
          y1="52.3598"
          y2="54.4498"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="17.25"
          x2="14.45"
          y1="58.0198"
          y2="59.5798"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <ellipse
          cx="36"
          cy="51.7194"
          rx="6.4518"
          ry="7.7514"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <ellipse
          cx="24.4558"
          cy="34.194"
          rx="7.7513"
          ry="6.4517"
          transform="matrix(0.3339 -0.9426 0.9426 0.3339 -15.9415 45.8287)"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <ellipse
          cx="46.8396"
          cy="34.1948"
          rx="6.4517"
          ry="7.7513"
          transform="matrix(0.9426 -0.3339 0.3339 0.9426 -8.7295 17.6024)"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M15.2952,65h9.0343c0,0,1.3738-13.3688,0-15.8101c-0.9984-1.7742-2.5479-5.2709-6.8527-5.1379 c-1.5576,0.0481-6.0111,1.347-4.7097,5.2514c1.8131,5.4394,3.4222,4.5051,4.2929,6.1777C18.2042,57.6789,15.2952,65,15.2952,65z"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M56.3242,65h-9.0343c0,0-1.3738-13.3688,0-15.8101c0.9984-1.7742,2.5479-5.2709,6.8527-5.1379 c1.5577,0.0481,6.0111,1.347,4.7097,5.2514c-1.8131,5.4394-3.4222,4.5051-4.2929,6.1777C53.4152,57.6789,56.3242,65,56.3242,65z"
        />
      </g>
    </svg>
  );
}
